import request from "./request";

const Configuracao = {
  obterQuadro: () => request.get("/composicao/quadro"),
  atualizarQuadro: quadro => request.put("/composicao/quadro", quadro),
  obterEncargos: () => request.get("/composicao/encargos"),
  atualizarEncargos: encargos => request.put("/composicao/encargos", encargos),
  obterEmpresaUsuarioLogado: () => request.get("/configuracoes/empresas"),
  atualizarEmpresa: empresa => request.put("/configuracoes/empresas", empresa, { "Content-Type": "multipart/form-data" })
};

export default Configuracao;



// WEBPACK FOOTER //
// ./src/services/configuarcao.js